import { ValueObject } from './value-object';

export class Cpf extends ValueObject<string> {
  constructor(cpf: string) {
    const isValid = Cpf.validate(cpf);
    if (!isValid) throw new Error('Not a CPF');

    super(cpf);
  }

  static validate(cpf: string): boolean {
    if (!cpf) {
      return false;
    }

    let sum: number;
    let remainder: number;
    sum = 0;
    if (cpf === '00000000000') return false;
    for (let i = 1; i <= 9; i++) sum += Number.parseInt(cpf.substring(i - 1, i)) * (11 - i);
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== Number.parseInt(cpf.substring(9, 10))) return false;
    sum = 0;
    for (let i = 1; i <= 10; i++) sum += Number.parseInt(cpf.substring(i - 1, i)) * (12 - i);
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== Number.parseInt(cpf.substring(10, 11))) return false;
    return true;
  }

  toString(): string {
    return this.value;
  }
}
